define([
	"dojo/_base/declare",
	"csi/widget/RadioToggleButton",
	"./_Plugin",
	"dojo/text!./resources/Button.html",
], function(declare,RadioToggleButton,_Plugin,template) {

	return declare([RadioToggleButton, _Plugin], {
		bText: true,
		cssStyle: "text-align",
		radioClass: "svgTextAlign",
		templateString: template,

		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			if (this.bText && shapes && shapes.length) {
				this.set("checked", this.editor.canvasApp.selection.getCommonTextValue(shapes, this.cssStyle, true) == this.cssValue, false);
			}
			return this.inherited(arguments);
		},

		/**
		 * @param  {Event} e
		 */
		onClick: function(e) {
			this.editor.setTextStyle(this.cssStyle, this.cssValue, this.checked);
		}
	});
});
